import styled from 'styled-components';
import { Layout } from 'antd';

export const ZeroWrapper = styled(Layout)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
`;
